export const REMEMBERED_PLANTING_DATE = "GDDPlantingDate"
export const REMEMBERED_THRESHOLD = "GDDThreshold"
export const REMEMBERED_GROUPING = "MainTableGrouping"
export const REMEMBERED_COEFFICIENT = "WaterBudgetCoefficient"
export const REMEMBERED_WEATHER_VARIABLE_KEY = "WeatherModelSelectedVariable"
export const REMEMBERED_VARIABLE_PERIOD = "WeatherModelIsMonthly"
export const REMEMBERED_SEASONAL_TABLE_FILTERS = "WeatherOverviewTableFilters"
export const REMEMBERED_CLIMATE_TABLE_FILTERS = "ClimateOverviewTableFilters"
